import React from 'react';
import { ShieldAlert, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { exitImpersonation, getImpersonationInfo } from '@/lib/tokenStorage';
import { toast } from 'sonner';

const ImpersonationBanner = () => {
  const info = getImpersonationInfo();
  if (!info) return null;

  const handleExit = () => {
    const ok = exitImpersonation();
    if (ok) {
      toast.success('Returned to admin session');
    }
    window.location.href = '/admin/subscribers';
  };

  return (
    <div
      className="w-full bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between gap-4 sticky top-0 z-[60] shadow-md"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <ShieldAlert className="h-5 w-5 flex-shrink-0" />
        <span className="text-sm truncate">
          <strong>Impersonation active.</strong> You are viewing as{' '}
          <span className="font-mono bg-amber-600/40 px-1.5 py-0.5 rounded" data-testid="impersonation-target-email">
            {info.target_email}
          </span>
          . All actions are audit-logged under your admin identity ({info.impersonator_email}).
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={handleExit}
        className="border-amber-900 text-amber-950 hover:bg-amber-600 flex-shrink-0"
        data-testid="exit-impersonation-btn"
      >
        <LogOut className="h-4 w-4 mr-1" /> Exit impersonation
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
